import React, {useState} from 'react';

import {InView} from 'react-intersection-observer';

import {EmbeddedObject} from 'app/general/structures/UserContentContainer/EmbeddedObject';
import {useAccountSettings} from 'app/settings/api';
import {VIDEO_ERROR_PNG} from 'app/urls';
import {useLazyVideo} from 'app/video/api';

interface Props {
  hashid: string;
}

export function VideoDisplay({hashid}: Props): JSX.Element {
  const [isVisible, setVisible] = useState(false);
  const staticURL = useAccountSettings(undefined, {
    refetchOnMountOrArgChange: 900,
  }).data!.STATIC_URL;

  const [trigger, videoData] = useLazyVideo();
  const {data: video, isLoading} = videoData;

  function loadVideo() {
    if (hashid != null && !isLoading) {
      trigger({hashid});
    }
  }

  function onInViewChange(inView: boolean) {
    if (inView && !isVisible) {
      loadVideo();
      setVisible(true);
    }
  }

  const videoPlaceholder = `${staticURL}images/video-placeholder.gif`;

  const objectProps =
    !isVisible || isLoading
      ? {
          coverImage: videoPlaceholder,
        }
      : // it means the app couldn't fetch the video - see fetchVideoDetails
      !video
      ? {
          coverImage: VIDEO_ERROR_PNG,
        }
      : {
          video,
          videoPlaceholder,
        };
  return (
    <InView as="div" threshold={0} onChange={onInViewChange}>
      <EmbeddedObject height={300} width={400} {...objectProps} />
    </InView>
  );
}
